import { LocalStorageKeys } from '../LocalStorageKeys';
import { LocalStorageService } from '../services/local-storage/local-storage.service';

/**
 * @method isLoggedIn
 * @returns boolean
 *
 * Checks whether the user is logged in or not
 */
export const isLoggedIn = (localStorage: LocalStorageService): boolean =>
  localStorage.getItem(LocalStorageKeys.ACCESS_TOKEN) !== null && localStorage.getItem(LocalStorageKeys.ACCESS_TOKEN) !== undefined;

/**
 * @method hasSelectedProfile
 * @returns boolean
 *
 * Checks whether the selected profile is available or not
 */
export const hasSelectedProfile = (localStorage: LocalStorageService): boolean =>
  localStorage.getItem(LocalStorageKeys.SELECTED_PROFILE_ID) !== null &&
  localStorage.getItem(LocalStorageKeys.SELECTED_PROFILE_ID) !== undefined;

/**
 * Clean local storage user data on logout
 */
export const cleanStorage = (localStorage: LocalStorageService): void => {
  localStorage.removeItem(LocalStorageKeys.SELECTED_PROFILE);
  localStorage.removeItem(LocalStorageKeys.SELECTED_PROFILE_ID);
  localStorage.removeItem(LocalStorageKeys.ACCESS_TOKEN);
  localStorage.removeItem(LocalStorageKeys.XAUTH_TOKEN);
  localStorage.removeItem(LocalStorageKeys.REFRESH_TOKEN);
  localStorage.removeItem(LocalStorageKeys.ID_TOKEN);
  localStorage.removeItem(LocalStorageKeys.PROFILES);
  localStorage.removeItem(LocalStorageKeys.ACCOUNT_EMAIL);

  // newrelic data
  // localStorage.removeItem('WZRK_X');
  // localStorage.removeItem('WZRK_PR');
  // localStorage.removeItem('WZRK_K');
};

/**
 * Set the cleanup variables to be used by reuse strategy
 */
export const cleanRoutes = (localStorage: LocalStorageService): void => {
  localStorage.setItem(LocalStorageKeys.CLEAN_ROUTES, 'true');
  localStorage.setItem(LocalStorageKeys.CHANGED_LANGUAGE, 'true');
};
